import { c as _c } from "react-compiler-runtime";
import Script from "next/script";
const hubspotPortalId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;

/**
 * HubSpot's script, which renders the opt-in cookie banner from the cookie
 * policy the portal publishes for this hostname (none published: no banner,
 * every category reported granted, no choice cookie). Mounted on both stacks:
 * the root layout renders it on the legacy build, and the composition root
 * renders it on the instrumentation stack, where HubSpot is the engine's banner
 * source (T-3834). Consent reaches the app only through the `_hsp` listener —
 * the HubSpot consent source on the new stack, the HubSpot adapter on the
 * legacy one.
 */
export function HubSpotCmpScript() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = hubspotPortalId ? <Script id="hs-script-loader" src={`https://js-na1.hs-scripts.com/${hubspotPortalId}.js`} strategy="afterInteractive" /> : null;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}